import EventBus from '../../services/EventBus';
import { msalLogout } from '../../services/msal/msal.services';
import AuthenticationRepository from '../AuthenticationRepository';

export default (response: Response, data: any, errorString: string) => {
  if (response.status === 401) {
    EventBus.error("Vous n'êtes plus connecté.");
    msalLogout();
  } else if (response.status === 500 && data.message === 'Unauthenticated.') {
    EventBus.error("Vous n'êtes plus connecté.");
    // TODO : delete AuthenticationRepository.logout() - actually delete that line create application bug
    AuthenticationRepository.logout();
    msalLogout();

    setTimeout(() => {
      document.location.reload();
    }, 3000);
  } else if (
    response.status === 500 &&
    errorString === '"kid" empty, unable to lookup correct key'
  ) {
    msalLogout();
  } else {
    EventBus.error(errorString);
  }
};
